//import { CancellationToken } from "./CancellationTokenSource";

//if (!Symbol.asyncIterator)
//    (<any>Symbol).asyncIterator = Symbol.for("asyncIterator");

//export class AsyncIteratorUtils {

//    public static async ToArray<T>(iterator: any /* AsyncIterableIterator<T> */, ct?: CancellationToken): Promise<Array<T>> { // AsyncIterableIterator<T> nepoužito jelikož všchny projekty, které by měli odkaz na Global by museli referencovat
//        //const i = <AsyncIterableIterator<T>>iterator;
//        const result: Array<T> = [];
//        if (iterator) {
//            if (!Reflect.has(iterator, Symbol.asyncIterator))
//                throw new TypeError('The "iterator" parameter is not AsyncIterableIterator<T>.');

//            for await (let item of iterator) {
//                result.push(item);
//                if (ct) ct.throwIfCancellationRequested();
//            }
//        }
//        return result;
//    }

//}
